<template>
  <div id="website">
    <div class="logo">
      <img :src="logoImg" alt="" />
    </div>
    <nav-menu v-if="!isFromWechat" @click="handleClick"></nav-menu>
    <popup :visiable="visiable" @close="closeDrawer"></popup>
    <img
      class="return"
      @click="handleBack"
      src="../../assets/store-detail/return.png"
      alt="返回"
    />
    <div id="header">
      <swiper
        v-if="imgList && imgList.length > 0"
        class="storeImg-swiper"
        :options="swiperOption"
      >
        <swiperSlide v-for="item in imgList" :key="item">
          <img :src="getImgUrl(item)" alt="" />
        </swiperSlide>
        <!-- <swiperSlide>Slide 2</swiperSlide>
        <swiperSlide>Slide 3</swiperSlide> -->
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="content-container">
      <div class="title">
        <img src="../../assets/store-detail/logo.png" alt="" />
        <div class="big-store-name">认证门店</div>
      </div>
      <div class="store-name">{{ storeData.F_FullName }}</div>
      <img
        class="store-img"
        :src="normalizeAssetUrl(storeData.F_Logo)"
        alt="门店图片"
      />
      <!-- 工商注册信息 -->
      <div class="store-info-item">
        <div class="divider"></div>
        <div class="main">
          <div class="info">{{ storeData.F_EnterpriseInformation }}</div>
          <div class="desc">工商注册信息</div>
        </div>
      </div>
      <!-- 门店地址 -->
      <div
        class="store-info-item"
        @click="
          () =>
            handleMapNav(
              storeData.F_Longitude,
              storeData.F_Latitude,
              storeData.F_Address,
              storeData.F_FullName
            )
        "
      >
        <div class="divider"></div>
        <div class="main">
          <div class="info">{{ storeData.F_Address }}</div>
          <div class="desc store-nav">
            <div>门店地址</div>
            <div class="nav"><i class="item-icon ri-send-plane-fill"></i></div>
          </div>
        </div>
      </div>
      <div class="store-info-item">
        <div class="divider"></div>
        <div class="main">
          <div class="info">{{ storeData.F_EnCode }}</div>
          <div class="desc">认证编号</div>
        </div>
      </div>
      <div class="equipment-title">设备信息</div>
      <div
        class="equipment-item"
        v-for="kk in storeData.EquipmentList"
        :key="kk.F_EnCode"
      >
        <div class="divider"></div>
        <div class="equipment-main">
          <img
            class="equipment-img"
            :style="{
              objectFit: kk.F_EquipmentType === 'C100' ? 'cover' : 'contain',
            }"
            :src="getImgUrl(kk.F_ImgPath)"
            alt=""
          />
          <div class="equipment-info">
            <div class="equipment-type">{{ kk.F_FullName }}</div>
            <div class="equipment-sort">
              <span>型号：</span>{{ kk.F_EquipmentType }}
            </div>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="footer">
        <div>如果您有任何有关设备的问题，欢迎联系我们</div>
        <div>
          If you have any questions about the equipment, please contact us
        </div>
        <div class="call">
          <img src="../../assets/store-detail/tel.png" alt="电话" />
          <span> <a :href="'tel://4000067956'">4000067956</a></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// let vm;
import NavMenu from "./components/NavMenu.vue";
import Popup from "./components/Popup.vue";
import axios from "axios";
import "vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { normalizeAssetUrl as normalizeLogoUrl } from "../../utils/asset-url";

export default {
  name: "Founds",
  components: {
    Popup,
    NavMenu,
    swiper,
    swiperSlide,
  },
  created() {
    // vm = this;
    document.title = "店铺详情";
    const queryObj = this.$route.query;
    // console.log("queryObj", queryObj);
    this.companyId = queryObj.F_CompanyId;
    if (queryObj && queryObj.formWechat) {
      // console.log("isFromwechat", this.isFromWechat);
      this.isFromWechat = true;
    }
  },
  mounted() {
    const formData = new FormData();
    formData.append("username", "system");
    formData.append("password", "qwert@12345!");
    axios
      .post("https://indibachn.com:5003/api/User/Login", formData)
      .then((loginRes) => {
        console.log("loginRes", loginRes);
        if (loginRes.data.code === 200) {
          // 拿下授权token
          localStorage.setItem("token", loginRes.data.data);
          axios
            .get(
              `https://indibachn.com:5003/api/Company/Info?companyId=${this.companyId}`,
              {
                headers: {
                  token: loginRes.data.data,
                },
              }
            )
            .then((res) => {
              // 拿到门店详情数据
              // console.log("res", res);
              if (res.data.code === 200) {
                this.storeData = res.data.data; // 全量数据
                this.imgList = res.data.data.F_ImgPath.split(",");
              }
            });
        }
      });
  },
  data() {
    return {
      logoImg: require("../../assets/home/logo.png"),
      visiable: false,
      isFromWechat: false,
      companyId: null,
      imgList: [],
      storeData: {},
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        loop: true,
        observer: true,
        observerParents: true,
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        //   // el: ".swiper-pagination",
        // },
      },
    };
  },

  watch: {},
  methods: {
    normalizeAssetUrl(url) {
      return normalizeLogoUrl(url);
    },
    handleBack() {
      this.$router.go(-1);
    },
    handleMapNav(F_Longitude, F_Latitude, F_Address, F_FullName) {
      const params = { F_Longitude, F_Latitude, F_Address, F_FullName };
      // console.log("params",params)
      this.$router.push({
        path: "/map",
        query: params,
      });
    },
    handleClick() {
      this.visiable = true;
    },
    closeDrawer() {
      this.visiable = false;
    },
    getImgUrl(item) {
      if (typeof item !== "string") return item;
      const normalizedItem = item.trim();
      if (normalizedItem.includes("https://indibachn.com")) {
        return normalizedItem;
      }
      return `https://indibachn.com/${normalizedItem.replace(/^\/+/, "")}`;
    },
  },
};
</script>

<style lang="less" scoped>
.return {
  position: absolute;
  z-index: 10;
  width: 12px;
  top: 20px;
  left: 12px;
}
#header {
  width: 100vw;
  position: absolute;
  top: 0;
  height: 300px;
  .storeImg-swiper {
    .swiper-wrapper {
      .swiper-slide {
        width: 100vw !important;
        height: 300px !important;
        img {
          height: 100% !important;
          width: 100% !important;
          object-fit: cover !important;
        }
      }
    }
    .swiper-button-next {
      background-image: url("../../assets/store-detail/right.png") !important;
    }
    .swiper-button-prev {
      background-image: url("../../assets/store-detail/left.png") !important;
    }
  }
}
.content-container {
  position: absolute;
  top: 260px;
  width: 86%;
  margin: 0 auto;
  left: 50%;
  /* top: 50%; */
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, 0%);
  padding: 12px;
  background: #f4f4f7;
  border: 1px solid #e8e9ee;
  box-shadow: 0px 10px 34px 9px rgb(105 105 106 / 13%);
  border-radius: 22px 22px 0 0;
  z-index: 100;
  .title {
    display: flex;
    width: 92%;
    background: #001a70;
    // box-shadow: 0px 11px 38px 0px rgb(0 0 0 / 26%);
    border-radius: 76px;
    height: 50px;
    justify-content: space-around;
    align-items: center;
    margin: 16px auto;
    img {
      height: 20px;
    }
    .big-store-name {
      color: white;
      font-size: 18px;
      // font-weight: bold;
    }
  }
  .store-name {
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    text-align: center;
    margin: 16px 0;
    font-size: 16px;
  }
  .store-img {
    width: 68vw;
    margin: 0 auto;
    margin-bottom: 32px;
  }
  .store-info-item {
    display: flex;
    flex-direction: row;
    height: 70px;
    margin-top: 16px;
    .divider {
      width: 6px;
      height: 100%;
      background: black;
    }
    .main {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    .info {
      flex: 3;
      display: flex;
      align-items: center;
      padding-left: 16px;
      /* width: 100%; */
      background: white;
      color: black;
    }
    .desc {
      flex: 1;
      display: flex;
      align-items: center;
      padding-left: 16px;
      background: #001a70;
      color: white;
    }
    .store-nav {
      display: flex;
      justify-content: space-between;
      .nav {
        margin-right: 12px;
      }
    }
  }
  .equipment-title {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: black;
  }
  .equipment-item {
    display: flex;
    flex-direction: row;
    height: 200px;
    .divider {
      width: 6px;
      height: 100%;
      background: black;
    }
    .equipment-main {
      flex: 1;
      display: flex;
      background: white;
      .equipment-img {
        flex: 1;
        width: 50%;
        object-fit: contain;
      }
      .equipment-info {
        flex: 1;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        color: black;
      }
    }
  }
  .footer {
    margin-top: 32px;
    font-size: 12px;
    .call {
      border-radius: 48px;
      height: 48px;
      display: flex;
      margin-top: 16px;
      background: #001a70;
      // box-shadow: 0px 11px 38px 0px rgb(0 0 0 / 26%);
      align-items: center;
      justify-content: center;
      img {
        height: 22px;
        margin-right: 12px;
      }
      span a {
        font-size: 17px;
        // font-weight: bold;
        color: white;
      }
    }
  }
}
</style>
